import './wdk_install_pop.scss';
const { __ } = wp.i18n;
import { useState ,useEffect} from 'react';

const AfterInstallWDKPop = ({ setIsAfterWDKPopupVisible, wUnique , wdblock }) => {

    const [wdkloader, setwdkloader] = useState(true);
    const [update_wdk, setupdate_wdk] = useState(false);

    const handleIframe = (event) => {
        if (event.data && event.data === "closePopup") {
          setupdate_wdk(true);
        }
    };
    window.addEventListener("message", handleIframe);
  
    const Close_loader = () => {

        if (wdkloader) {
        const handleIframe = (event) => {
            if (event.data && event.data === "openPopup") {
            setwdkloader(false);
            }
        };

        window.addEventListener("message", handleIframe);
        }
    }

    const openAfterWDKPopup = (wID,update) => {
        if(wID) {
            setSelectedWUnique(wID);
            setIsAfterWDKPopupVisible(true);
        }

        if (update || update_wdk) {
            let blockList = nxtext_ajax_object.dashData.blockList || {};
                        
            Object.keys(blockList).forEach(widgetKey => {
                const widget = blockList[widgetKey];
                if (widget?.block_cate === "WDesignKit" && widget.uniqueId === wdblock) {
                    blockList[widgetKey].w_type = "Publish";
                }
            });
            nxtext_ajax_object.dashData.blockList = blockList;
            
        }
        setIsAfterWDKPopupVisible(false); 
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                openAfterWDKPopup(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [openAfterWDKPopup]);

    return (
        <>
            <div className='nxt-wdkit-popup' onClick={() => openAfterWDKPopup(false)}>
                <div className='nxt-content-bg iframe-height'  onClick={(e) => e.stopPropagation()}>
                    <div className="nxt-popup-close" onClick={() => openAfterWDKPopup() }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="gray" d="M15.393 3.725a.625.625 0 1 1 .883.884L10.885 10l5.391 5.392.044.047a.625.625 0 0 1-.88.88l-.047-.044L10 10.884 4.61 16.275a.625.625 0 0 1-.884-.883L9.117 10 3.726 4.609a.625.625 0 1 1 .884-.884L10 9.116l5.392-5.391Z"/></svg>
                    </div>
                    <div className='nxt-popup-wdk-body'>
                        {wdkloader && (
                            <div className="theplus-wkit-loader-outer">
                                <div className="theplus-wkit-loader-inner"></div>
                            </div>
                        )}
                         <iframe id='wdk-ifram-content' src={wUnique}  style={{ width: '100%', height: '510px', border: 'none' ,display: wdkloader ? 'none' : 'block'}} ></iframe>
                         {Close_loader()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AfterInstallWDKPop;

